import {Component, Input} from '@angular/core';
import {LottiService} from 'src/app/_services/lotti.service';
import {CaratteristicaSchedaTecnica} from "../../_models/CaratteristicaSchedaTecnica";
import {OrganizzazioniService} from "../../_services/organizzazioni.service";
import {SaveMessage} from "../../_helpers/save-message";

@Component({
  selector: 'app-caratteristica-scheda-tecnica',
  templateUrl: './caratteristica-scheda-tecnica.component.html',
  styleUrls: ['./caratteristica-scheda-tecnica.component.scss'],
  standalone: false
})
export class CaratteristicaSchedaTecnicaComponent {
  @Input() codArt = '';
  @Input() schemaCodifica = '';
  @Input() tipoScheda = '';
  @Input() codiceEtichetta = '';
  @Input() rifLottoAlfa = '';
  valore = '';
  loading = false;

  constructor(
    private lottoService: LottiService,
    private organizzazioneService: OrganizzazioniService,
    private saveMessage: SaveMessage
  ) { }

  confirmCaratteristica() {
    const caratteristica: CaratteristicaSchedaTecnica = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      schemaCodifica: this.schemaCodifica, tipoScheda: this.tipoScheda,
      codArt: this.codArt, codiceEtichetta: this.codiceEtichetta,
      valoreAlfa: this.valore, valoreNum: 0,
      rifLottoAlfa: this.rifLottoAlfa
    };
    this.loading = true;
    this.lottoService.importaCaratteristicaLottoAsync(this.organizzazioneService.organizzazioneId, caratteristica)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione della caratteristica."))
      .finally(() => this.loading = false);
  }
}
